import { render, staticRenderFns } from "./IntroDialog.vue?vue&type=template&id=edbb4d4e"
import script from "./IntroDialog.vue?vue&type=script&lang=js"
export * from "./IntroDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports